import { SetupTab as Component } from './component';
import Connector from './connector';
import { ConnectorProps } from './SetupTab.proptype';

export interface SetupTabProps extends Omit<ConnectorProps, 'component'> {}

export const SetupTab = (props: SetupTabProps) => <Connector {...props} component={Component} />;
